import React, { FunctionComponent } from 'react';
import { Platform, CoverItem } from 'sofa-reborn-react';
import { StyledSpanWrapper, StyledSpan, StyledCover } from './CoverPopoverMenuStyle';

type Props = {
	platform: Platform;
	replaceCovers: CoverItem[];
	selectedCover: CoverItem;
	missingCover: boolean;
	covers: CoverItem[];
	onCoverClick?: (coverItem: CoverItem) => void;
};

const CoverPopoverMenu: FunctionComponent<Props> = (props) => {
	const { onCoverClick } = props;
	const covers = props.missingCover ? props.replaceCovers : props.covers;
	const coverElements = covers.map(function (cover) {
		const active = cover.articleId === props.selectedCover.articleId ? 'active' : '';
		return (
			<StyledSpanWrapper
				platform={props.platform}
				onClick={(): void => onCoverClick && onCoverClick(cover)}
				onKeyDown={(e): void => {
					if (e.key === 'Enter' || e.key === ' ') {
						onCoverClick && onCoverClick(cover);
					}
				}}
				key={cover.articleId}
				role="button"
				tabIndex={0}
			>
				<StyledSpan
					className={active}
					platform={props.platform}
					color={cover.color}
					borderColor={cover.borderColor as string}
				></StyledSpan>
			</StyledSpanWrapper>
		);
	});

	return <StyledCover platform={props.platform}>{coverElements}</StyledCover>;
};

export default CoverPopoverMenu;
